









import {
  Component,
  Vue
} from 'vue-property-decorator'
import Map from '@/components/Map.vue'
import Panel from '@/components/Panel.vue'

@Component({
  components: {
    Map,
    Panel
  }
})
export default class Home extends Vue {
  mapIsOpen = true
  panelIsOpen = false

  openMap() {
    this.mapIsOpen = true
    this.panelIsOpen = false
  }

  openPanel() {
    this.mapIsOpen = false
    this.panelIsOpen = true
  }
}
